module.exports = __webpack_public_path__ + "static/media/1014624.16f95581.jpg";